export const BUY = 'BUY'
export const SELL = 'SELL'
